import { ErrorBoundary } from '@sentry/react';
import { useCrossPlatformNavigationItems } from '@/hooks/navigation/useCrossPlatformNavigationItems';
import { SideNavFooterLinks } from '../common/SideNavFooterLinks';
import { FallbackSideNavFooterLinks } from '../fallback/FallbackSideNavFooterLinks';

const CrossPlatformSideNavFooterLinksWithData = () => {
  const { footer } = useCrossPlatformNavigationItems();
  return <SideNavFooterLinks navItems={footer} />;
};

export const CrossPlatformSideNavFooterLinks = () => (
  <ErrorBoundary fallback={<FallbackSideNavFooterLinks />}>
    <CrossPlatformSideNavFooterLinksWithData />
  </ErrorBoundary>
);
